export interface ExperienceEntry {
    company: string
    role: string
    startDate: string
    endDate: string
    accomplishments: string[]
}

export interface Resume {
    experience: ExperienceEntry[]
}

export const resume: Resume = {
    experience: [
        {
            company: 'Block, Cash App',
            role: 'Software Engineer, iOS Graphics',
            startDate: '2026',
            endDate: 'Present',
            accomplishments: [
                'Used AI accelerated workflows to develop and prototype 3D visualizations for the Cash App Card.',
            ],
        },
        {
            company: 'Carrier Corporation Digital Foundry',
            role: 'Lead UX Engineer',
            startDate: '2021',
            endDate: '2025',
            accomplishments: [
                'Designed and created advanced UI components for data visualization in React/TypeScript.',
                'Designed and created dashboards and internal tools in React/TypeScript, including a centralized project hub adopted across 10+ teams to track outcomes, metrics, and resources.',
                'Partnered with the Carrier Intelligence division to design AI product interfaces and select AI tool chains - delivering a project intake and lifecycle management platform.',
            ],
        },
        {
            company: 'Raytheon Technologies Digital Accelerator',
            role: 'Associate Director of Software Engineering',
            startDate: '2017',
            endDate: '2021',
            accomplishments: [
                'Served as an engineer and designer who shaped UX decisions while building production-grade prototypes in a Lean Startup setting.',
                'Built a Flight Profile Optimization iPad app in Swift for Collins Aerospace that is used in the cockpit to improve fuel efficiency and guide flight decisions.',
                'Designed and shipped an iOS app for Otis technicians that supports maintenance evaluations, integrates with backend systems, and works offline through background sync and local persistence.',
                'Produced large-format lobby visuals with WebGL and Unity, including a real-time flight tracker built with TypeScript and Vue that mapped active flights using Collins components.',
            ],
        },
        {
            company: 'Method',
            role: 'Lead Design Technologist',
            startDate: '2014',
            endDate: '2017',
            accomplishments: [
                'Redesigned the McDonald’s mobile experience with high-fidelity iOS prototypes written in Swift.',
                'Acted as bridge between design and engineering, ensuring seamless handoff from concept to implementation.',
                'Led motion design and interaction concepts through advanced prototyping on iOS/Swift.',
            ],
        },
        {
            company: 'IDEO',
            role: 'Senior Interaction Designer',
            startDate: '2012',
            endDate: '2014',
            accomplishments: [
                'Created interactive prototypes for mobile, web, and experimental platforms using user-centered design methods.',
                'Led development of the first SoulCycle mobile app, bringing the brand’s community and booking experience onto iOS.',
                'Served as lead iOS developer on multiple projects; explored creative coding and early VR prototyping with Oculus Rift.',
            ],
        },
        {
            company: 'Independent',
            role: 'Developer',
            startDate: '2010',
            endDate: '2012',
            accomplishments: [
                'Developed Uzu, a generative art app that became Apple’s App of the Week and was featured in the App Store Hall of Fame.',
            ],
        },
        {
            company: 'Colossal Squid Industries',
            role: 'Development Lead',
            startDate: '2008',
            endDate: '2010',
            accomplishments: [
                'Created award-winning interactive work for major brands at a leading digital agency.',
                'Focused on immersive Flash-based experiences, physics simulations, and coded animation.',
            ],
        },
        {
            company: 'Earlier Roles',
            role: 'Interactive design, art direction, and development',
            startDate: '2001',
            endDate: '2008',
            accomplishments: [
                'Pixel — Senior Interactive Art Director: Concept and development of experiential brand sites; specialized in coded animation effects.',
                'Bep Interactive Marketing — Interaction Designer: Designed large-scale corporate websites and micro-sites.',
                'OMS Photography — Web Developer/Digital Manager: Built intranet systems with PHP/MySQL; led digital asset workflows.',
                'Interactive Technologies — Web/Print Designer: Led branding and design projects across web, print, and product packaging.',
            ],
        },
    ],
}

/** Stable ids for coordinated hide/show transitions in ContentFlow (one per experience row). */
export function resumeExperienceRowTransitionId(index: number): string {
    return `resume-row-${index}`
}

export function resumeExperienceRowTransitionIds(): string[] {
    return resume.experience.map((_, index) => resumeExperienceRowTransitionId(index))
}

/** File in `public/resume/`; used for the on-site download link. */
export const RESUME_PDF_FILENAME = 'Jason Smith Resume Mar 9 - 2026.pdf'

export const resumePdfHref = `/resume/${encodeURIComponent(RESUME_PDF_FILENAME)}`
